import { useFeatureValue } from '@shared/core/featureFlags';
import { addError } from '@shared/utils/logger';

interface WebsiteInterceptExternalHotelLinksPayload {
  regexList: string[];
}

const isWebsiteInterceptExternalHotelLinksPayloadValid = (payload: WebsiteInterceptExternalHotelLinksPayload) => {
  return payload && 'regexList' in payload;
};

const parseRegexString = (regexString: string): RegExp => {
  if (!regexString.startsWith('/')) {
    addError('regexParseError', { type: 'invalid_format', regexString });
    throw new Error(`Invalid regex format: ${regexString}`);
  }

  const lastSlashIndex = regexString.lastIndexOf('/');
  if (lastSlashIndex <= 1) {
    addError('regexParseError', { type: 'invalid_format', regexString });
    throw new Error(`Invalid regex format: ${regexString}`);
  }

  const pattern = regexString.slice(1, lastSlashIndex);
  const flags = regexString.slice(lastSlashIndex + 1);

  try {
    return new RegExp(pattern, flags);
  } catch (e) {
    if (e instanceof Error) {
      addError('regexParseError', { type: 'parse_error', regexString, error: e });
      throw new Error(`Failed to parse regex: ${regexString} → ${e.message}`);
    } else {
      addError('regexParseError', { type: 'unknown_error', regexString, error: e });
      throw new Error(`Unknown error while parsing regex: ${regexString}`);
    }
  }
};

export const useWebsiteInterceptExternalHotelLinks = (link: string = '') => {
  const { value, payload } = useFeatureValue('websiteInterceptExternalHotelLinks');
  let showIntercept = false;
  const websiteInterceptExternalHotelLinksPayload = payload as WebsiteInterceptExternalHotelLinksPayload;
  if (isWebsiteInterceptExternalHotelLinksPayloadValid(websiteInterceptExternalHotelLinksPayload)) {
    showIntercept =
      value === 'on' &&
      websiteInterceptExternalHotelLinksPayload.regexList.some(regex => {
        try {
          const regexObj = parseRegexString(regex);
          return regexObj.test(link);
        } catch (error) {
          return false;
        }
      });
  }
  return showIntercept;
};
